import React from "react";
import AnyChart from 'anychart-react'
import anychart from "anychart";
const { Component } = React;

export default class DataAgeChart extends Component {

  constructor(props) {
    super(props);
    this.containerId = props.containerId;
    this.chart = anychart.area();
    this.series = null;

    this.chart.yAxis().title('Usuarios');
    this.chart.xAxis().title(false);
    this.chart.xAxis().labels().padding([0, 0, 0, 0])

    this.chart.yGrid(true)
    this.chart.xGrid(false);
    this.chart.yScale().minimum(0);

    this.chart.animation(true);

    this.chart
      .title()
      .enabled(true)
      .text('Vejez de los datos')
      .orientation('bottom')
      .padding([10,0,10,0])
      .fontSize(14)



    this.chart
      .tooltip()
      .positionMode('chart')
      .anchor('right-top')
      .position('right-top')
      .offsetX(50)
      .offsetY(50)

    this.chart
      .tooltip()
      .title(true)

    this.chart.padding([20,20,0,20])

    this.chart.interactivity().hoverMode('by-x');
  }

  generateChart(inputData) {
    var dataAge = inputData.dataAge;
    var intervals = inputData.intervals;

    var data = []
    var max = 0;

    for (var index = dataAge.length-1; index >= 0; index--) {
      var timeLabel;
      var label;
      if (index < dataAge.length-1) {
        timeLabel = intervals[index] < 3600000 ? (intervals[index]/60000) + "m" :  (intervals[index]/3600000) + "h" 
        label = "<" + timeLabel
      } else {
        timeLabel = intervals[index-1] < 3600000 ? (intervals[index-1]/60000) + "m" :  (intervals[index-1]/3600000) + "h" 
        label = ">" + timeLabel
      }
      data.push([label, dataAge[index]]);
      if (max < dataAge[index])
        max = dataAge[index];
    }
    
    if (this.series == null) {
      var dataSet = anychart.data.set(data);
      this.series = this.chart.splineArea(dataSet);
      
      this.series.name('Usuarios');
      this.series.color('blue');
      this.series
        .markers()
        .enabled(true)
        .type('circle')
        .size(4)
        .stroke('1.5 #fff')
        .zIndex(100);
    } else {
      this.series.data(data);
    }

    this.chart.yScale().maximum(Math.round(max*1.2));

    this.chart.container(this.containerId);

    this.chart.draw();

    return this.chart;
  }

  render() {
    return (
      <AnyChart 
        id={this.containerId}
        intance={ this.props.data != null ? this.generateChart(this.props.data) : null}/>
    )
  }

}
